var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ps-app d-flex flex-column min-vh-100"},[_c('b-link',{staticClass:"sr-only sr-only-focusable ps-skip",attrs:{"href":"#main"}},[_vm._v("Skip to content")]),_c('app-navbar'),_c('main',{staticClass:"flex-grow-1",attrs:{"id":"main"}},[_c('router-view')],1),_c('app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }